export const getEnv = () => {
  switch (process.env.ENV_NAME) {
    case 'local':
    case 'dev':
      return 'app-dev.';
    case 'stg':
      return 'app-staging.';
    default:
      return 'app.';
  }
};

export const getLoginEnvUrl = () => {
  switch (process.env.ENV_NAME) {
    case 'local':
    case 'dev':
      return 'https://login.dev.cbinsights.com';
    case 'stg':
      return 'https://login.staging.cbinsights.com';
    default:
      return 'https://login.cbinsights.com';
  }
};

export const buildEnvURL = (path: string) => {
  return `https://${getEnv()}cbinsights.com/${path}`;
};
